import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/logos/logo_squared.webp")